import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=95e2821a&scoped=true&"
import script from "./chapter.vue?vue&type=script&lang=js&"
export * from "./chapter.vue?vue&type=script&lang=js&"
import style0 from "./chapter.vue?vue&type=style&index=0&id=95e2821a&prod&lang=less&"
import style1 from "./chapter.vue?vue&type=style&index=1&id=95e2821a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e2821a",
  null
  
)

export default component.exports